import './App.css';
import React from 'react';
import AppRoutes from "./routes/AppRoutes";

// Importar Toastify
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

 
  return (
    <>
      <AppRoutes />
      <ToastContainer />   {/* Aquí lo dejas */}
    </>
  )
}

export default App;
